import React from 'react';
import { Route } from '../Routing/types';
import {
  DietSettingsSex,
  DietSettingsHeight,
  DietSettingsDateOfBirth,
  DietSettingsUserSummary,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/sex',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsSex />,
  },
  {
    path: '/birth-date',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDateOfBirth />,
  },
  {
    path: '/height',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsHeight />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsUserSummary />,
  },
];

export default descendantRoutes;
